import React from 'react'
import useListCmsPaginatedContents from 'hooks/useListCmsPaginatedContents'
import ListWrapper from 'redesign/components/organisms/ListWrapper'
import EmptyPage from 'redesign/components/organisms/empty-pages'
import { EMPTY_PAGE_VARIANTS } from 'redesign/components/organisms/empty-pages/constants'
import WikiCard from 'redesign/components/organisms/wiki-card'
import { CONTENT_TYPES } from 'types/cms'
import type { WikiPagesTemplateProps } from '../types'

const ContentWikiPages: React.FC<WikiPagesTemplateProps> = ({ ownerId }) => {
  const { list, loadMore, loading, hasMoreElements } = useListCmsPaginatedContents({
    contentType: CONTENT_TYPES.page,
    ownerId,
  })

  return (
    <ListWrapper
      loadMore={loadMore}
      showLoadMoreButton={hasMoreElements}
      isLoading={loading}
      hasContent={Boolean(list.length)}
      noContentBlock={<EmptyPage variant={EMPTY_PAGE_VARIANTS.noWiki} />}
    >
      {list.map((content) => (
        <WikiCard key={content.uuid} content={content} />
      ))}
    </ListWrapper>
  )
}

export default ContentWikiPages
